import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { FullScreenLoader } from "components/FullScreenLoader/FullScreenLoader";
import { getDocumentMeta } from "utils/getDocumentMeta";

export const DphBrowserRouter: React.FC = ({ children }) => (
  <BrowserRouter>
    <DphRoutingBoundary>{children}</DphRoutingBoundary>
  </BrowserRouter>
);

export const DphHandoffRedirect: React.FC<{
  destination: string;
  hash?: string;
}> = ({ destination, hash = "" }) => {
  React.useEffect(() => {
    const query = new URLSearchParams({ destination });
    window.location.replace(`/dph-handoff/start?${query.toString()}${hash}`);
  }, [destination, hash]);

  return <FullScreenLoader />;
};

export const DphRoutingBoundary: React.FC = ({ children }) => {
  const { pathname, search, hash } = useLocation();
  const shouldRedirect =
    getDocumentMeta("dph_routing") === "1" &&
    (pathname === "/my-account" || pathname.startsWith("/my-account/"));

  return shouldRedirect ? (
    <DphHandoffRedirect destination={pathname + search} hash={hash} />
  ) : <>{children}</>;
};
